<template>
	<div id="indexpage" v-title :data-title="title" style="height:100%;">
		<leftnav mkcode="D" itemcode="D-ZSHJ" :smScrennFull="true"></leftnav>
		<!-- 弹框 -->

		<div class="por" style="background-color: #041034;height:100%;">
			<!-- 全屏开始 -->
			<i class="el-icon-full-screen swiper_fullscreen" @click="screen()"></i>
			<!-- 全屏结束 -->
			<div class="index-swiper centerpage">
				<!-- <h2 class="title dataswipertitle" @mouseover="drawer = true" ><span v-if="userdata.countyText ==''">{{userdata.cityText}}</span><span v-if="userdata.countyText !=''">{{userdata.countyText}}</span>{{title}}<i class="el-icon-arrow-down dataswipertitle_icon"></i></h2> -->
				<daswiperNav :title="title" :indexnum="4" navcode="ZSDDT"  :fulltitle="true"></daswiperNav>
				<div class="indexflex zhaoshangmap">
					<div class="col7 colbox">
						<ul class="zsmap_leftbar">
							<li v-for="list in pagedata.extend.notionList">
								<h5 class="title">{{ list.label }}</h5>
								<p><strong class="numf">
										<countTo :endVal='list.count' :startVal='0' :props="contodefault">100</countTo>
									</strong><span>家</span></p>
							</li>
							<!-- <li>
								<h5 class="title">信息技术</h5>
								<p><strong class="numf"><countTo :endVal='370' :startVal='0' :props="contodefault">370</countTo></strong><span>家</span></p>
							</li>
							<li>
								<h5 class="title">高技术船舶</h5>
								<p><strong class="numf"><countTo :endVal='100' :startVal='0' :props="contodefault">100</countTo></strong><span>家</span></p>
							</li>
							<li>
								<h5 class="title">新材料</h5>
								<p><strong class="numf"><countTo :endVal='50' :startVal='0' :props="contodefault">50</countTo></strong><span>家</span></p>
							</li>
							<li>
								<h5 class="title">化学化工</h5>
								<p><strong class="numf"><countTo :endVal='120' :startVal='0' :props="contodefault">120</countTo></strong><span>家</span></p>
							</li> -->
						</ul>
						<div class="zsmap_leftmap">
							<h3 class="title">目标招商企业数</h3>
							<div class="zsmap_num">
								<!-- <countTo :endVal='8' :props="contodefault"></countTo><em>,</em> <countTo :props="contodefault" :endVal='1'></countTo><countTo :props="contodefault" :endVal='3'></countTo><countTo :props="contodefault" :endVal='5'></countTo> -->
								<span v-for="(item, i) in total">{{ item }}</span>
							</div>
							<div id="zsmap_map"></div>
						</div>
					</div>
					<div class="col3 colbox">
						<div class="zsmap_barpie oh flexcss transparentbg">
							<div class="fl zsmap_bar">
								<h3 class="blocktitle">各城市目标企业数量排名</h3>
								<div id="zsmap_bar"></div>
							</div>
							<div class="fl zsmap_bar">
								<h3 class="blocktitle">全国目标企业数量占比</h3>
								<div id="zsmap_pie"></div>
							</div>
						</div>
						<div class="zsmap_enterprise transparentbg">
							<h3 class="blocktitle">重点企业列表</h3>
							<div class="zsmap_tab">
								<div class="zsdt_th">
									<ul class="flexcss">
										<li class="zsdt_td1">简称</li>
										<li class="zsdt_td2">所在地</li>
										<li class="zsdt_td2">联系电话</li>
									</ul>
								</div>
								<div class="zddt_scrollbox">
									<vue-seamless-scroll :data="pagedata.list" :class-option="defaultOption"
										class="zddt_scroll">
										<!-- :data="colors"  :class-option="defaultOption" -->
										<ul class="flexcss zsdt_td" v-for="(list, i) in pagedata.list"
											:class="i % 2 != 0 ? 'zsdt_tdbg' : ''">
											<li class="zsdt_td1" @click="routerlinkid('/enterprises', list.stockCode)">
												{{ list.shortName != '' ? list.shortName : list.title }}</li>
											<li class="zsdt_td2 ">{{ list.area }}</li>
											<li class="zsdt_td2 ">{{ list.phone }}</li>
										</ul>
									</vue-seamless-scroll>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template> 
<script>
import mappng from '../../assets/images/mapbg.png';
export default {
	name: 'zhaoshangditu',
	data() {
		return {
			isCollapse: false,
			isFullscreen: false,
			direction: "ltr",  //btt
			direction2: "btt",  //btt
			drawer: false,
			drawer2: false,
			modal: false,
			title: "招商大地图", bgcolor: "#041034",
			usernotionlistsave: [],
			userdata: {},
			pagedata: { extend: {}, },
			mapurl: 'map/city/321200.json',
			contodefault: {
				duration: 1000, autoplay: true,
			},
			islogin: false,
			flag: true,
			swipernum: 3,
			endvalue1: 1,
			endvalue2: 2,
			endvalue3: 0,
			listdata: [],
			public_tooltip: {
				trigger: 'axis',
				backgroundColor: 'rgba(255,255,255,0.9)',
				borderColor: '#ddd',
				borderWidth: '1',
				textStyle: {
					color: '#000',
					fontSize: 14,
				}
			},
			mapurl: 'map/city/321200.json',
			colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
			landType: [],
			startCharts: null,
			total: '0000',
			//假数据  
		}
	},
	props: {
		msg: String,
	},
	computed: {
		defaultOption() {
			return {
				step: 0.7, // 数值越大速度滚动越快
				limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			}
		}
	},
	mounted() {
		document.getElementById('app').style.background = this.bgcolor;
		this.userdata = this.getuserinformain();
		// console.log(this.userdata);  
		if (this.userdata.edition < 1) {
			var _this=this;
			alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function () {
				_this.routerself('/totalEnterprises');
			}, 1000)
			return;
		}
		this.bus.$emit('loading', true);
		this.getajasdata();
	},
	methods: {
		getajasdata() {
			var _this = this;
			// this.bus.$emit('loading', true);
			console.log(this.title);
			this.$axios.get(this.$api.cyl.govsaaschart.investment(), { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// console.log('getajasdata',res.data); 
				_this.pagedata = res.data;
				console.log(res.data.list)
				var mapdata = res.data.cityList.province;
				var chartdata = res.data.cityList.city;
				_this.chianmapFun('zsmap_map', mapdata);
				_this.rankFun('zsmap_bar', chartdata);
				_this.zsmap_pieFun('zsmap_pie', chartdata);
				_this.bus.$emit('loading', false);
				_this.total = res.data.totalRecord + '';
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},

		//1大地图
		chianmapFun(el, data) {
			var myChart = echarts.init(document.getElementById(el));
			// JSON文件(地图数据)路径
			var loadedDataURL = 'map/china.json';
			let cityCode = 'china';
			// 显示加载动画效果,可以在加载数据前手动调用该接口显示加载动画，在数据加载完成后调用 hideLoading 隐藏加载动画。
			// myChart.showLoading();
			let mapName = cityCode;
			$.getJSON(loadedDataURL, function (geoJson) {
				console.log('geoJson:', geoJson)
				// 注册地图名字(tongren)和数据(geoJson) 
				echarts.registerMap(mapName, geoJson);
				// 隐藏动画加载效果。
				myChart.hideLoading();
				// 图表配置项
				for (var i = 0; i < data.length; i++) {
					if (data[i].name == '内蒙古自治区' || data[i].name == '黑龙江省') {
						data[i].name = data[i].name.substr(0, 3); //匹配前两字
						data[i].value = data[i].count;
					} else {
						data[i].name = data[i].name.substr(0, 2); //匹配前两字
						data[i].value = data[i].count;
					}
				}
				var option = {
					backgroundColor: this.bgcolor,
					selectedMode: 'multiple', // 选中效果固话
					tooltip: { // 提示框
						show: true,
						trigger: 'item',
						// formatter: function (params) {
						// 	// console.log(params)
						//   return params.name;
						// }
					},
					// geo: {
					// 	map: mapName,
					// 	aspectScale:.9,
					// 	layoutCenter: ['50.3%', '50.5%'],
					// 	layoutSize: '110%',
					// 	silent: true,
					// 	roam: false, 
					// 	center:[104.87,34.2],//[底图左右位置数值越大越往左，底图距上下位置数值越大越往下]
					// 	z: 0,
					// 	itemStyle: {
					// 		normal: {
					// 			areaColor: '#07232c',
					// 			shadowColor: 'rgba(0, 0, 0, 1)',
					// 			shadowBlur: 0,
					// 			shadowOffsetX: 0,
					// 			shadowOffsetY: 1,
					// 			borderColor: '#07232c',
					// 			borderWidth: 0.5,
					// 		},
					// 		emphasis: {
					// 			areaColor: 'rgba(0,0,0,0)',
					// 			borderWidth: 1,
					// 			color: 'green',
					// 			label: {
					// 				show: true,
					// 			},
					// 		},
					// 	},
					// },
					series: [{
						name: 'map',
						type: "map", // map3D / map
						map: mapName,
						zoom: 1,
						label: { // 标签的相关设置
							show: true, // (地图上的城市名称)是否显示标签 [ default: false ]
							// distance: 5, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离
							//formatter:, // 标签内容格式器
							textStyle: { // 标签的字体样式
								color: '#ffffff', // 地图初始化区域字体颜色 
								fontSize: 14, // 字体大小
								opacity: 1, // 字体透明度 
							},
							emphasis: {
								show: true,
								color: '#ffffff',
							}
						},
						tooltip: { //提示框组件。
							show: true,
							alwaysShowContent: true,
							hoverAnimation: true,
							trigger: 'item', //触发类型 散点图
							enterable: true, //鼠标是否可进入提示框
							transitionDuration: 0.3, //提示框移动动画过渡时间
							triggerOn: 'click',
							borderWidth: '1px',
							borderRadius: '4',
							// borderColor: '#00B2AC',
							backgroundColor: "rgba(24,144,255,.6)",
							textStyle: {
								color: 'rgba(255,255,255,1)'
							},
							padding: [10, 10],
							formatter: function (params) {
								var result = '';
								if (!isNaN(params.value)) {
									result = '省份：' + params.name + '<br>' + '目标企业数：' + params.value;
								} else {
									result = '省份：' + params.name;
								}
								return result;
							},

						},
						itemStyle: { // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
							// areaColor: 'rgba(95,158,160,0.5)', // 地图板块的颜色
							areaColor: '#07232c', // 地图板块的颜色
							opacity: 1, // 图形的不透明度 [ default: 1 ]
							borderWidth: 2, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
							borderColor: '#298faf' // 图形描边的颜色。[ default: #333 ]
						},
						emphasis: {
							show: true,
							itemStyle: {
								areaColor: '#169593', // 地图板块的颜色
								opacity: 1, // 图形的不透明度 [ default: 1 ]
								borderWidth: 2, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
								borderColor: '#298faf',// 图形描边的颜色。[ default: #333 ]

							}
						},
						// zoom:1.2,	
						data: data,

					}],
				};
				option.series[0].center = [105.87, 38];
				// 设置图表实例的配置项以及数据，万能接口，所有参数和数据的修改都可以通过setOption完成，ECharts 会合并新的参数和数据，然后刷新图表。
				myChart.setOption(option);
			});
			// 地图点击事件
			// myChart.on('click', function(params) {
			// 	console.log(params);
			// });
			// var hourIndex = 0;
			// var fhourTime = null;
			// fhourTime = setInterval(function() {
			// 	myChart.dispatchAction({
			// 		type: "downplay",
			// 		seriesIndex: 0,

			// 	});
			// 	myChart.dispatchAction({
			// 		type: "highlight",
			// 		seriesIndex: 0,
			// 		dataIndex: hourIndex
			// 	});
			// 	myChart.dispatchAction({
			// 		type: "showTip",
			// 		seriesIndex: 0,
			// 		dataIndex: hourIndex
			// 	});
			// 	hourIndex++;
			// 	if (hourIndex > data.length) {
			// 		hourIndex = 0;
			// 	}
			// }, 3000);
			// //鼠标移入停止轮播
			// myChart.on("mousemove", function(e) {
			// 	clearInterval(fhourTime)
			// 	myChart.dispatchAction({
			// 		type: "downplay",
			// 		seriesIndex: 0,
			// 	});
			// 	myChart.dispatchAction({
			// 		type: "highlight",
			// 		seriesIndex: 0,
			// 		dataIndex: e.dataIndex
			// 	});
			// 	myChart.dispatchAction({
			// 		type: "showTip",
			// 		seriesIndex: 0,
			// 		dataIndex: e.dataIndex
			// 	});
			// })
			// //鼠标移出恢复轮播
			// myChart.on("mouseout", function() {
			// 	fhourTime = setInterval(function() {
			// 		myChart.dispatchAction({
			// 			type: "downplay",
			// 			seriesIndex: 0,

			// 		});
			// 		myChart.dispatchAction({
			// 			type: "highlight",
			// 			seriesIndex: 0,
			// 			dataIndex: hourIndex
			// 		});
			// 		myChart.dispatchAction({
			// 			type: "showTip",
			// 			seriesIndex: 0,
			// 			dataIndex: hourIndex
			// 		});
			// 		hourIndex++;
			// 		if (hourIndex > data.length) {
			// 			hourIndex = 0;
			// 		}
			// 	}, 3000);
			// })


			//funjiewei
		},


		//2各城市目标企业数量排名
		rankFun(el, data) {
			var charPie3currentIndex = 0, isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var chart = echarts.init(document.getElementById(el));
			var _this = this, xline = [], seriesline = [];
			var datalen = data.length - 1;
			for (var i = 0; i < data.length; i++) {
				xline.push(data[datalen - i].name);
				seriesline.push(data[datalen - i].count);
			};
			// console.log('111',data,'222',xline,'333',seriesline)
			var option = {
				title: {
					text: "", left: 25, top: 20, textStyle: { color: '#eee', fontSize: 16 }
				},
				tooltip: {
					trigger: 'axis',
					// formatter: '{c}',
					backgroundColor: 'rgba(255,255,255,0.9)',
					borderColor: '#ddd',
					borderWidth: '1',
					textStyle: {
						color: '#000',
						fontSize: 14,
						confine: true, //提示框被遮挡  是否将 tooltip 框限制在图表的区域内
					},
					formatter: function (params) {
						// console.log(params);
						var result = ''
						var dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff"></span>'    // 定义第一个数据前的圆点颜色
						result += dotHtml + ' 目标企业数： ' + params[0].data;
						// console.log(params);
						return result;

					}
				},
				color: _this.colors,
				grid: { x: 50, y: 30, x2: 50, y2: 45, show: true, borderWidth: 0, },
				label: { show: true, position: 'right', valueAnimation: true, color: '#fff', },
				xAxis: {
					type: 'value', axisTick: { show: true }, boundaryGap: [0, 0.01], axisLine: { show: true, lineStyle: { color: '#eee', fontSize: 10 } }, splitLine: { show: false }, axisLabel: { color: "#fff", },
					// min:0,				//最小值
					// max: 300,			//最大值
					// interval: 500,		//步长值 
				},
				yAxis: { type: 'category', splitLine: { show: false }, axisTick: { show: true }, axisLine: { show: true, lineStyle: { color: '#eee', } }, data: xline, axisLabel: { fontSize: 12, color: '#eee' } },
				series: [{ data: seriesline, type: 'bar', barWidth: 18, color: '#1890ff', }]
			};
			chart.setOption(option);
			// var startCharts = null;
			// // 2、鼠标移动上去的时候的高亮动画
			// chart.on('mouseover', function(param) {
			// 	isSet = false
			// 	clearInterval(startCharts)
			// 	// 取消之前高亮的图形
			// 	chart.dispatchAction({
			// 		type: 'downplay',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// 	// 高亮当前图形
			// 	chart.dispatchAction({
			// 		type: 'highlight',
			// 		seriesIndex: 0,
			// 		dataIndex: param.dataIndex
			// 	})
			// 	// 显示 tooltip
			// 	chart.dispatchAction({
			// 		type: 'showTip',
			// 		seriesIndex: 0,
			// 		dataIndex: param.dataIndex
			// 	})
			// });
			// var chartHover = function() {
			// 	var dataLen = option.series[0].data.length
			// 	// 取消之前高亮的图形
			// 	chart.dispatchAction({
			// 		type: 'downplay',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// 	charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
			// 	// 高亮当前图形
			// 	chart.dispatchAction({
			// 		type: 'highlight',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// 	// 显示 tooltip
			// 	chart.dispatchAction({
			// 		type: 'showTip',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// }
			// startCharts = setInterval(chartHover, 2000)
			// // 4、鼠标移出之后，恢复自动高亮
			// chart.on('mouseout', function(param) {
			// 	if (!isSet) {
			// 		startCharts = setInterval(chartHover, 2000)
			// 		isSet = true
			// 	}
			// });
		},

		//全国目标企业数量占比
		zsmap_pieFun(el, data) {
			var charPie3currentIndex = 0, isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var zsmap_pie = echarts.init(document.getElementById(el));
			var _this = this;
			for (var i = 0; i < data.length; i++) {
				data[i].value = data[i].count;
			}
			var option = {
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: '{b}' + '\n' + '{c}',
				},
				// graphic: {						//给环形图添加中心图片
				//         elements: [
				//                  {
				//                 type: 'image',
				//                 style: {
				//                     image:require("../../assets/images/zsMapbg1.png") ,
				//                     width: 85,
				//                     height: 80
				//                 },
				//                 left: '35.5%',
				//                 top: '36%'

				//                  }
				//         ]
				//     },
				legend: {
					show: false, top: 'center', right: '15%', textStyle: { color: "#eee", fontSize: 12, lineHeight: 100 }, orient: 'vertical', itemWidth: 6, itemHeight: 6, icon: 'circle'	//图例圆形 
				},
				series: [
					{
						top: 0,
						// left:60,
						type: 'pie', radius: ['35%', '48%'],
						label: { show: true, color: '#fff', fontSize: 12, position: 'outside', formatter: '{b}' + '\n' + '{c}', },
						center: ["53%", "50%"],   //center: ["35%", "43%"]图表距左跟上位置rotate:90
						labelLine: {
							showAbove: true,
							verticalAlign: 'middle',
							length: 10,
							length2: 10,
							length3: 10,
						},
						emphasis: { show: true, },
						data: data,
					}
				]
			};
			zsmap_pie.setOption(option);
			// var startCharts = null;
			// // 2、鼠标移动上去的时候的高亮动画
			// zsmap_pie.on('mouseover', function(param) {
			// 	isSet = false
			// 	clearInterval(startCharts)
			// 	// 取消之前高亮的图形
			// 	zsmap_pie.dispatchAction({
			// 		type: 'downplay',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// 	// 高亮当前图形
			// 	zsmap_pie.dispatchAction({
			// 		type: 'highlight',
			// 		seriesIndex: 0,
			// 		dataIndex: param.dataIndex
			// 	})
			// 	// 显示 tooltip
			// 	zsmap_pie.dispatchAction({
			// 		type: 'showTip',
			// 		seriesIndex: 0,
			// 		dataIndex: param.dataIndex
			// 	})
			// });
			// var chartHover = function() {
			// 	var dataLen = option.series[0].data.length
			// 	// 取消之前高亮的图形
			// 	zsmap_pie.dispatchAction({
			// 		type: 'downplay',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// 	charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
			// 	// 高亮当前图形
			// 	zsmap_pie.dispatchAction({
			// 		type: 'highlight',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// 	// 显示 tooltip
			// 	zsmap_pie.dispatchAction({
			// 		type: 'showTip',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// }
			// startCharts = setInterval(chartHover, 2000)
			// // 4、鼠标移出之后，恢复自动高亮
			// zsmap_pie.on('mouseout', function(param) {
			// 	if (!isSet) {
			// 		startCharts = setInterval(chartHover, 2000)
			// 		isSet = true
			// 	}
			// });
		},

	}
}
</script>

<style scoped="scoped">#app {
	background-color: #041034;
}

@import url("../../css/dataswiper.css");</style>
